module.exports = __webpack_public_path__ + "img/cubatao.5587c64e.png";